import gql from "graphql-tag";
import EditableCommentFields from "./EditableCommentFields";
import ReactableFields from "./ReactableFields";

export default gql`
  fragment AssetDiscussionCommentReplyFields on AssetDiscussionCommentReply {
    _id
    shortId
    bodyAsPlainText
    postedAt

    author {
      _id
      email
      fullName
      pictureUrl
      isSiteAdmin
      isBlack
    }

    viewerCanDestroy
    viewerCanEdit

    ...EditableCommentFields
    ...ReactableFields
  }

  ${EditableCommentFields}
  ${ReactableFields}
`;
